import React from 'react';

import { Col, Collapse, Divider, Image, Row, Tabs, Typography } from 'antd';

import LoadingComponents from '@components/LoadingComponents';
import { useIntegration } from '@hooks/IntegrationContext';
import { useReference } from '@hooks/ReferenceContext';
import TabBarCode from './TabBarCode';
import TabClassification from './TabClassification';
import TabDataProduct from './TabDataProduct';
import TabPhotos from './TabPhotos';
import TabValueProduct from './TabValueProduct';
import TabVideo from './TabVideo';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

interface ReferencesContentTableProps { }

const ReferencesContentTable: React.FC<ReferencesContentTableProps> = () => {
  const { hasMerpIntegration } = useIntegration();
  const { loadingReferenceProducts, referenceProducts } = useReference();

  if (loadingReferenceProducts) return <LoadingComponents />;

  return (
    <>
      {referenceProducts?.map((product) => (
        <>
          <div className="d-flex">
            <div className="ml-4">
              <Image
                width={160}
                src={
                  product?.color?.imageColorReferences?.length
                    ? product?.color?.imageColorReferences[0]?.image_small
                    : ''
                }
                preview={{
                  src: product?.color?.imageColorReferences?.length
                    ? product?.color?.imageColorReferences[0]?.image
                    : '',
                }}
                style={{ borderRadius: '6px' }}
                fallback="data:image/png;base64,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"
              />
            </div>
            <div style={{ marginLeft: '16px' }}>
              <Title className="ml-4" style={{ color: '#555' }} level={4}>
                {product.name}
              </Title>
              <Row gutter={[16, 16]} className="ml-4">
                <Col className="gutter-row">
                  <Title level={5}>Tamanho</Title>
                  <Text>{product.size}</Text>
                </Col>

                <Col className="gutter-row">
                  <Title level={5}>Cor</Title>
                  <Text>{product.color ? product.color.name : 'Sem informação'}</Text>
                </Col>

                <Col className="gutter-row">
                  <Title level={5}>Unidade</Title>
                  <Text>{product.measuredUnit}</Text>
                </Col>
              </Row>
            </div>
          </div>

          <Collapse className="mt-2 mb-8" ghost>
            <Collapse.Panel header="Exibir informações" key="1" style={{ fontWeight: 'bold' }}>
              <Tabs>
                {!hasMerpIntegration &&
                  <TabPane tab="Dados do Produto" key="1">
                    <TabDataProduct product={product} />
                  </TabPane>
                }
                {!hasMerpIntegration &&
                  <TabPane tab="Valor do Produto" key="2">
                    <TabValueProduct product={product} />
                  </TabPane>
                }
                <TabPane tab="Código de Barras" key="3">
                  <TabBarCode barCodes={product?.barCodes ? product?.barCodes : []} />
                </TabPane>
                {!hasMerpIntegration &&
                  <TabPane tab="Classificações" key="4">
                    <TabClassification classifications={product?.classifications ? product?.classifications : []} />
                  </TabPane>
                }
                <TabPane tab="Fotos" key="5">
                  <TabPhotos
                    images={product?.color?.imageColorReferences ? product?.color?.imageColorReferences : []}
                  />
                </TabPane>
                {!hasMerpIntegration &&
                  <TabPane tab="Vídeo" key="6">
                    <TabVideo referenceCode={product?.ReferenceCode ? product?.ReferenceCode : ''} />
                  </TabPane>
                }
              </Tabs>
            </Collapse.Panel>
          </Collapse>

          <Divider />
        </>
      ))}
    </>
  );
};

export default ReferencesContentTable;
